import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  isMedium: {
    width: theme.spacing(8),
    height: theme.spacing(8),
    fontSize: theme.spacing(3),
  },
  isLarge: {
    width: theme.spacing(18),
    height: theme.spacing(18),
    fontSize: theme.spacing(4),
  },
}))

export default useStyles
